import React from 'react';

const URL_PATTERN = /(https?:\/\/[^\s<>")]+)/g;
const TRAILING_PUNCTUATION = /[.,;:!?)\]]+$/;

const LinkifiedText = ({ text }) => {
    if (typeof text !== 'string' || !text) return text ?? null;

    const parts = text.split(URL_PATTERN).filter((part) => part !== '');
    if (parts.length === 1 && !/^https?:\/\//.test(parts[0])) return text;

    return (
        <>
            {parts.map((part, index) => {
                if (!/^https?:\/\//.test(part)) {
                    return <React.Fragment key={`t-${index}`}>{part}</React.Fragment>;
                }
                const trailing = (part.match(TRAILING_PUNCTUATION) || [''])[0];
                const href = trailing ? part.slice(0, -trailing.length) : part;
                return (
                    <React.Fragment key={`u-${index}`}>
                        <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="docfirst__label-link"
                        >
                            {href}
                        </a>
                        {trailing}
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default LinkifiedText;

